import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { motion } from "framer-motion";
import "../../Styles/Admin/UserGrowthchart.css";
import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../../apiConfig";

const UserGrowthChart = () => {
  const [userGrowthData, setUserGrowthData] = useState([]);

  useEffect(() => {
    const fetchUserGrowthData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/admin/user-growth`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("idToken")}`,
          },
        });

        const data = await response.json();
        if (data.success) {
          setUserGrowthData(data.userGrowthData);
        } else {
          console.error("Failed to fetch user growth data:", data.message);
        }
      } catch (err) {
        console.error("Error fetching user growth data:", err);
      }
    };

    fetchUserGrowthData();
  }, []);

  return (
    <motion.div
      className="user-growth-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
    >
      <h2 className="user-growth-title">User Growth</h2>
      <div className="chart-height">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={userGrowthData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
            <XAxis dataKey="month" stroke="#9CA3AF" />
            <YAxis stroke="#9CA3AF" />
            <Tooltip
              contentStyle={{
                backgroundColor: "rgba(31, 41, 55, 0.8)",
                borderColor: "#4B5563",
              }}
              itemStyle={{ color: "#E5E7EB" }}
            />
            <Line
              type="monotone"
              dataKey="users"
              stroke="#8B5CF6"
              strokeWidth={2}
              dot={{ fill: "#8B5CF6", strokeWidth: 2, r: 4 }}
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </motion.div>
  );
};

export default UserGrowthChart;
